// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__22k_2","overflow":"styles_overflow__37ATy"};